<template>
  <div class="tovar_main">
    <!-- begin nav_line  -->
    <div class="nav_line_main">
      <BubblesNavbar
        :product_block_prefix="product_block_prefix"
        :product_bubble_prefix="product_bubble_prefix"
        :level="0"
        :height="60"
        :categories-prop="getParentCategories()"
      ></BubblesNavbar>
    </div>
    <!--     end nav_line -->

    <ProductBlock
      :is-last="index === productCategories.length - 1"
      :key="index"
      v-for="(category, index) in productCategories"
      :category="category"
      :prefix="product_block_prefix"
    />
  </div>
</template>

<script>
  import ProductBlock from '@/components/Default/ProductBlock'
  import BubblesNavbar from '@/components/Default/BubblesNavbar'
  import {CREATE_SELECTED_CATEGORY_FOR_LEVEL} from '@/store/mutations.type'

  export default {
    name: 'Products',
    data() {
      return {
        product_block_prefix: 'product_block_',
        product_bubble_prefix: 'product_bubble_'
      }
    },
    components: {
      ProductBlock,
      BubblesNavbar
    },
    watch: {},
    mounted() {
    },
    computed: {
      productCategories() {
        let categories = []
        for (let i in this.$store.getters.categories) {
          if (
            !this.$store.getters.categories[i].work_time ||
            this.$store.getters.categories[i].work_time.is_working_now ||
            (this.$store.getters.categories[i].work_time.from !== null &&
              this.$store.getters.categories[i].work_time.to !== null)
          ) {
            categories.push(this.$store.getters.categories[i])
          }
        }
        return categories
      }
    },

    methods: {
      checkSelectedCategoryLevelExist(level) {
        if (!this.$store.getters.selectedCategory[level]) {
          this.$store.commit(CREATE_SELECTED_CATEGORY_FOR_LEVEL, level)
        }
      },
      getParentCategories() {
        let categories = []
        for (let i in this.productCategories) {
          if (this.productCategories[i].parent_id === null) {
            categories.push(this.productCategories[i])
          } else {
            this.checkSelectedCategoryLevelExist(this.productCategories[i].level)
          }
        }
        return categories
      }
    }
  }
</script>
